class ProductCollage extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.splideInit();
    }
    
    splideInit() {
      const productLoops = this.querySelector('.product-catelogue_wrapper');
     if (productLoops) {
      new Splide(productLoops, {
        type: 'splide',
        perPage: 2,
        perMove: 1,
        gap: '2rem',
        grid: {
          rows: 2, // 2 rows
          cols: 1,  // 2 columns (2x2 grid)
          gap: {
            row: '2rem',
            col: '2rem',
          },
        },
        breakpoints: {
          768: {
            grid: false, // Disable grid on mobile, show as carousel
            perPage: 2,  // Show 2 items per page
          },
          480: {
            grid: false, // Disable grid on smaller mobile screens
            perPage: 2,  // Show 2 items per page
            gap: '10px',
          }
        },
        pagination: true,  // Show dots navigation on mobile
        arrows: false      // Disable arrows for mobile
      }).mount(window.splide.Extensions);
     }
   
    }
  }
  customElements.define("product-collage", ProductCollage);